import { enumObject, EnumValue } from '@app/base';
import { GetCurrentUserQuery, GetUserLookupsQuery, UserAccountFragment } from './graphql';

export interface ChangePasswordRequest {
  current: string;
  new: string;
}

export type UserAccount = UserAccountFragment;

export type User = NonNullable<GetCurrentUserQuery['currentUser']>;

export type UserLookup = GetUserLookupsQuery['users'][number];

const ROLE_VALUES = [
  'GLOBAL_ADMIN',
  'ADMIN',
  'PERFORMER',
  'PATIENT',
  'SECURITY',
  'COORDINATOR',
  'CARE_HOME_STAFF'
] as const;
export type Role = EnumValue<typeof ROLE_VALUES>;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Role = enumObject('Role', ROLE_VALUES);

export const ROLE_VALUES_FOR_EMPLOYEES: Role[] = [
  'ADMIN',
  'PERFORMER',
  'SECURITY',
  'COORDINATOR',
  'CARE_HOME_STAFF'
];

const USER_STATUS_VALUES = ['Active', 'Creating', 'Deactivated', 'Locked'] as const;
export type UserStatus = EnumValue<typeof USER_STATUS_VALUES>;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserStatus = enumObject('UserStatus', USER_STATUS_VALUES);
